module.exports = __webpack_public_path__ + "media/lotus-flower-bomb-wale.7fc9f4e3.mp3";